module.exports = __webpack_public_path__ + "static/media/iconNote.b9d0b5fa.png";